import { IMAGE_DESKTOP } from '../elements/assets'
import { IMAGE_MOBILE } from '../elements/assets'

export const QUOTE = `
...on quote_Entry {
  id
  typeHandle
  backgroundColor

  ${ IMAGE_DESKTOP }

  ${ IMAGE_MOBILE }
  
  logo {
    url
    title
    width
    height
  }
  
  quote
  
  photo {
    url
    title
    width
    height
  }
  
  username
  position
}
`